export enum AppTitle {
  Default = 'Ascend Ops',
  ECS = 'Activate Model Manager',
}

export enum AppClientIds {
  ECS = 'ecs',
  ActivateDemo = 'activatedemo',
}
